module.exports = __webpack_public_path__ + "static/summercamp-d8808207002feff41c67cc14a5d8badc.png";